import { FileText, GitCompareArrows, DatabaseZap } from 'lucide-react';
export const API_BASE_URL = window.location.port === "2800" 
  ? process.env.REACT_APP_API_BASE_URL || 'http://itgfrapapp800.prod.altengroup.dir:2800' 
  : window.location.origin;

export const SUGGESTIONS = [
  {
    icon: FileText,
    iconColor: "text-blue-500",
    title: "Summarize a Section",
    prompt: "Can you summarize the key findings from the financial report?",
  },
  {
    icon: GitCompareArrows,
    iconColor: "text-green-500",
    title: "Compare information",
    prompt: "Compare the Q1 and Q2 sales strategies from the internal memos.",
  },
  {
    icon: DatabaseZap,
    iconColor: "text-purple-500",
    title: "Extract specific data",
    prompt: "What were the customer satisfaction scores mentioned in the last project review?",
  },
];

export const EXAMPLE_PROMPTS = [
  { icon: "📄", text: "Answer RFP documentation" },
  { icon: "📊", text: "Conduct a competitor analysis" },
  { icon: "💬", text: "Provide feedback on communication" },
];